export function getQueryParams() {
  return `?aid=${
    localStorage.getItem("aid") ? localStorage.getItem("aid") : ""
  }&pkey=${localStorage.getItem("pkey") ? localStorage.getItem("pkey") : ""}`;
}



// WEBPACK FOOTER //
// ./src/components/utils.js